export const Studio2Images = [
    {
        original: 'https://i.ibb.co/Fw7Qw99/IMG-20210714-111012.jpg',
        thumbnail: 'https://i.ibb.co/MVNzVbb/IMG-20210714-111012.jpg',
    },
    {
        original: 'https://i.ibb.co/8rkmzxh/IMG-20210714-111355.jpg',
        thumbnail: 'https://i.ibb.co/2vJF8Mb/IMG-20210714-111355.jpg',
    },
    {
        original: 'https://i.ibb.co/6B9FzvD/IMG-20210714-110919.jpg',
        thumbnail: 'https://i.ibb.co/sHxqn5s/IMG-20210714-110919.jpg',
    },
    {
        original: 'https://i.ibb.co/z6jNNXS/IMG-20210713-144945.jpg',
        thumbnail: 'https://i.ibb.co/tLk33qb/IMG-20210713-144945.jpg',
    },
    {
        original: 'https://i.ibb.co/MDJVVB9/IMG-20210714-111406.jpg',
        thumbnail: 'https://i.ibb.co/DDjCCrL/IMG-20210714-111406.jpg',
    },
];